<template>
  <div id="device-manager" class="mg_bot50 clearfix">
    <data-table
      :getData="getDevices"
      :widthTable="'100%'"
      :classHeader="'header-css'"
      @DataTable:finish="onDatatableFinished"
      ref="datatable"
      :limit="10"
      :column="4"
      class="datatable scroll"
    >
      <template slot="colgroup_slot">
        <colgroup>
          <col width="45%" />
          <col width="25%" />
          <col width="15%" />
          <col width="15%" />
        </colgroup>
      </template>
      <th class="text-left">{{ $t("user.device") }}</th>
      <th class="text-left">{{ $t("user.recent_activity") }}</th>
      <th class="text-left cl_ip">{{ $t("account.ip_address") }}</th>
      <th class="text-right"></th>
      <template slot="body" slot-scope="props">
        <tr
          class="device-manager"
          :class="props.index % 2 === 0 ? 'odd' : 'active'"
        >
          <td class="device-name text-left">
            <div class="over-flow-text" :title="genTitle(props.item.name)">
              <!-- {{ props.item.kind | uppercaseFirst | trimString }},
              {{ props.item.operating_system | trimString }},
              {{ props.item.platform | trimString }} -->
              {{ props.item.name | trimString }}
            </div>
          </td>
          <td class="text-left">{{ convertDate(props.item.updated_at) }}</td>
          <td class="text-left cl_ip">{{ props.item.latest_ip_address }}</td>
          <td class="text-right">
            <button
              class="actions btn button_close_history"
              @click.prevent="confirmRemoveDevice(props.item)"
            >
              <i class="icon-close2"></i>
            </button>
            <button
              v-if="props.item.connectionCount >= 2"
              class="actions btn button_drop_history"
              @click="activeRow(props.item)"
            >
              <i
                class="glyphicon"
                :class="props.item.isActiveRow ? 'icon-arrow2' : 'icon-arrow1'"
              ></i>
            </button>
          </td>
        </tr>
        <template v-if="props.item.isActiveRow">
          <tr
            class="device-manager text-left"
            :class="{ odd: (props.index + 1) % 2 === 0 }"
            v-for="connection in props.item.user_connection_histories"
            :key="
              props.item.id +
              '-' +
              (connection.created_at || '') +
              '-' +
              (connection.ip_address || '')
            "
          >
            <td></td>
            <td>{{ connection.created_at | timestampToDate }}</td>
            <td>{{ connection.ip_address }}</td>
            <td></td>
          </tr>
        </template>
      </template>
    </data-table>
  </div>
</template>

<script>
import rf from "../../lib/RequestFactory";
import moment from "moment";

export default {
  props: {
    userId: { type: [Number, String] },
  },
  data() {
    return {
      moment: moment,
    };
  },
  watch: {
    userId(newValue) {
      this.$refs.datatable.refresh();
    },
  },
  methods: {
    convertDate(date) {
      var dateFormat = "YYYY-MM-DD HH:mm:ss";
      var testDateUtc = moment.utc(date);
      return testDateUtc.format(dateFormat);
    },
    genTitle(name) {
      return window._.startCase(name);
    },
    onDatatableFinished() {
      if (!this.$refs.datatable || !this.$refs.datatable.rows) {
        return;
      }
      window._.each(this.$refs.datatable.rows, (item) => {
        item.isActiveRow = false;
      });
    },
    activeRow(item) {
      item.isActiveRow = !item.isActiveRow;
      this.$forceUpdate();
    },
    getDevices(params) {
      if (window._.isEmpty(`${this.userId}`)) {
        return Promise.resolve({ data: [] });
      }

      this.isActiveRow = -1;

      const callParams = { ...params, userId: this.userId };

      return rf
        .getRequest("UserRequest")
        .getDeviceRegister(callParams)
        .then((res) => {
          const raw = res ?? {};
          const list = Array.isArray(raw)
            ? raw
            : raw.data ?? raw.devices ?? raw.items ?? [];

          const mapped = (list || []).map((d) => {
            const rawHistories =
              d.user_connection_histories ?? d.userConnectionHistories ?? [];

            const histories = rawHistories.map((c) => ({
              created_at: c.created_at ?? c.createdAt ?? null,
              ip_address:
                c.ip_address ?? c.ipAddress ?? c.latestIpAddress ?? "",
            }));

            const sortedHistories = histories.sort((a, b) => {
              const ta = a.created_at ? moment(a.created_at).valueOf() : 0;
              const tb = b.created_at ? moment(b.created_at).valueOf() : 0;
              return tb - ta;
            });

            const firstHistory = sortedHistories[0] || null;

            return {
              id: d.id,
              user_id: d.user_id ?? d.userId,
              kind: d.kind ?? "",
              operating_system: d.operating_system ?? d.operatingSystem ?? "",
              platform: d.platform ?? "",
              updated_at: firstHistory
                ? firstHistory.created_at
                : d.updated_at ?? d.updatedAt ?? d.createdAt ?? null,
              latest_ip_address: firstHistory
                ? firstHistory.ip_address
                : d.latest_ip_address ?? d.latestIpAddress ?? "",
              user_connection_histories: firstHistory
                ? sortedHistories.slice(1)
                : [],
              connectionCount: rawHistories.length,
              isActiveRow: false,
              name: d.name ?? d.name ?? "",
            };
          });

          res.data = { data: mapped };
          return res;
        });
    },

    refresh() {
      this.$refs.datatable.refresh();
    },
    confirmRemoveDevice(deviceId) {
      window.ConfirmationModal.show({
        type: "primary",
        title: "",
        content: this.$t("account.modal.confirm_trusted_device"),
        btnCancelLabel: window.i18n.t("common.action.no"),
        btnConfirmLabel: window.i18n.t("common.action.yes"),
        onConfirm: () => {
          this.removeDevice(deviceId);
        },
      });
    },
    removeDevice(item) {
      const params = {
        userId: item.user_id,
        deviceId: item.id,
      };
      rf.getRequest("UserRequest")
        .deleteDevice(params)
        .then((res) => {
          this.$toastr("success", this.$t("address.deleted_success"));
          this.refresh();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/sass/variables";

.device-manager {
  &.active {
    height: auto;
    max-height: auto;
    background-color: transparent;
  }
}
.icon-arrow2,
.icon-arrow1,
.icon-close2 {
  font-size: 16px;
  color: $color-jungle-green;
  &:hover {
    color: $color-eden;
  }
}

#device-manager {
  max-height: 441px;
  overflow-y: auto;
  .datatable {
    .width-title {
      min-width: 160px;
      max-width: 160px;
    }
    button {
      background: transparent;
      box-shadow: none;
      border: 0;
      width: 27px;
      height: 27px;
      padding: 4px;
      float: right;
      &:hover {
        background-color: transparent;
        color: $color_yellow_text;
      }
    }
  }
}
.button_close_history {
  margin-left: 10px;
}
.cl_ip {
  min-width: 115px;
}
</style>
<style lang="scss">
@import "@/assets/sass/variables";

@media (max-width: 1400px) {
  #device-manager {
    table {
      thead {
        th {
          padding: 5px 3px;
        }
      }
      tbody {
        td {
          font-size: $font_root;
          padding: 8px 5px 4px 5px;
        }
      }
      .device-name {
        .over-flow-text {
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
</style>
